import React, { useEffect, useState } from "react";
import CaraouselCard from "../Carousel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./CardDetail.module.css";
import BankCaraouselCard from "../BankCarousel";

function CardDetail({
  cardlist,
  setSelectedValue,
  selectedValue,
  BankType = false,
  selectedUserid,
  type=""
}) {

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!cardlist || !Array.isArray(cardlist)) {
    return null;
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding:'10px'
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding:'10px',
          dots: false,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding:'10px',
          dots: false,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding:'10px',
          dots: false,
        }
      },
    ]
  };

  return (
    <>
      <div
        // className={/*greenCheck ? styles.greenCard :*/ styles.mainCard}
        className={(cardlist && cardlist.length > 3) || (screenWidth <= 1400 && screenWidth >= 992 && cardlist && cardlist.length > 2) || 
          (screenWidth < 992 && cardlist && cardlist.length > 1) ? styles.listCard : styles.listCardfor2}
      >
        {(cardlist && cardlist.length > 3) || (screenWidth <= 1400 && screenWidth >= 992 && cardlist && cardlist.length > 2) || 
        (screenWidth < 992 && cardlist && cardlist.length > 1) ? (
          <>
          <Slider {...settings} className={styles.slicPrev}>
            {cardlist &&
              cardlist
                .slice(Math.max(cardlist.length - 15, 0))
                .reverse()
                .map((item) =>
                  BankType === true ? (
                    <BankCaraouselCard
                      uniqueId={item.bankAccountId}
                      selectedItem={item}
                      setSelectedValue={setSelectedValue}
                      selectedValue={selectedValue}
                      selectedUserid={selectedUserid}
                      type={type}
                    />
                  ) : (
                    <CaraouselCard
                      uniqueId={item.userAccountId}
                      selectedItem={item}
                      setSelectedValue={setSelectedValue}
                      selectedValue={selectedValue}
                      selectedUserid={selectedUserid}
                    />
                  )
                )}
          </Slider>
        </>
        ) : (
          <>
          {cardlist
            .map((item) =>
              BankType === true ? (
                <BankCaraouselCard
                  uniqueId={item.bankAccountId}
                  selectedItem={item}
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  selectedUserid={selectedUserid}
                  fixedwidth={true}
                  type={type}
                />
              ) : (
                <CaraouselCard
                  uniqueId={item.userAccountId}
                  selectedItem={item}
                  setSelectedValue={setSelectedValue}
                  selectedValue={selectedValue}
                  selectedUserid={selectedUserid}
                  fixedwidth={true}
                />
              )
            )}
        </>
        )}
      </div>
    </>
  );
}

export default CardDetail;
